const placedata2021=[
  {
    Name: "Maru kiranbhai parshotambhai",
    Roll: "15BEC061",
    Company: "Bytes technolabs pvt. ltd.",
  },
  { Name: "Priyansh shashikant ringe", Roll: "16BEC024", Company: "Evosys" },
  {
    Name: "Chaudhary vaisvikkumar rameshbhai",
    Roll: "16BEC025",
    Company: "Bacancy software llp",
  },
  { Name: "Abhay sharma", Roll: "17BEC002", Company: "E infochip" },
  { Name: "Aditya jain", Roll: "17BEC003", Company: "Cognizant" },
  {
    Name: "Adodariya kashyap popatbhai",
    Roll: "17BEC004",
    Company: "Einfochips ( an arrow company)",
  },
  {
    Name: "Agrini chaturvedi",
    Roll: "17BEC005",
    Company: "Almstom transportation pvt ltd",
  },
  {
    Name: "Airan shruti atulkumar",
    Roll: "17BEC007",
    Company: "Sls corporation",
  },
  { Name: "Akshay mishra", Roll: "17BEC008", Company: "Evosys" },
  {
    Name: "Aman rajkumar kshatriya",
    Roll: "17BEC009",
    Company: "Zs associates",
  },
  { Name: "Anant raina", Roll: "17BEC010", Company: "Cypress semiconductor" },
  {
    Name: "Asmita asim kumar barik",
    Roll: "17BEC011",
    Company: "Secure meter",
  },
  {
    Name: "Ayushee samridhi",
    Roll: "17BEC013",
    Company: "Synopsys(india) pvt.ltd.",
  },
  {
    Name: "Bhanushali meetkumar vasantbhai",
    Roll: "17BEC015",
    Company: "Cypress semiconductor",
  },
  { Name: "Bhargava arpita sandeep", Roll: "17BEC016", Company: "Cognizant" },
  { Name: "Bhavin patel", Roll: "17BEC017", Company: "Cadence" },
  {
    Name: "Bhensdadiya kevin prabhulal",
    Roll: "17BEC019",
    Company: "Secure meters limited ",
  },
  {
    Name: "Bohra rohan jagdish",
    Roll: "17BEC020",
    Company: "Einfochips ( an arrow company)",
  },
  {
    Name: "Chinmay khurana",
    Roll: "17BEC022",
    Company: "Almstom transportation pvt ltd",
  },
  { Name: "Desai sapan nikunj", Roll: "17BEC023", Company: "Evosys" },
  { Name: "Devansh chawla", Roll: "17BEC024", Company: "L & t limited" },
  {
    Name: "Dholakia himanshu rajeshkumar",
    Roll: "17BEC025",
    Company: "Samyak infotech pvt ltd",
  },
  { Name: "Dhwani rakesh malkan", Roll: "17BEC026", Company: "L & t limited" },
  {
    Name: "Divyesh kalpeshkumar sankhla",
    Roll: "17BEC027",
    Company: "E infochip",
  },
  { Name: "Dobariya priti bharatbhai", Roll: "17BEC028", Company: "Cadence" },
  {
    Name: "Gajjar devanshu sanjeevkumar",
    Roll: "17BEC029",
    Company: "Einfochips ",
  },
  { Name: "Gangwani gunjan mukesh", Roll: "17BEC030", Company: "E infochip" },
  {
    Name: "Gautam rashi rajesh",
    Roll: "17BEC031",
    Company: "Almstom transportation pvt ltd",
  },
  {
    Name: "Gurmeet jasvir khurana",
    Roll: "17BEC032",
    Company: "At pune -will send through whatapp",
  },
  { Name: "Hetanshu gupta", Roll: "17BEC034", Company: "Hcl technologies" },
  { Name: "Honey nikhil shah", Roll: "17BEC035", Company: "E infochip" },
  {
    Name: "Jain dhruv vinodkumar",
    Roll: "17BEC037",
    Company: "Arm embedded technologies",
  },
  {
    Name: "Jain khushi purvesh",
    Roll: "17BEC038",
    Company: "Commscope pvt ltd",
  },
  {
    Name: "Jaykumar prafulbhai domadiya",
    Roll: "17BEC039",
    Company: "Cadence",
  },
  {
    Name: "Jahnavi jha",
    Roll: "17BEC041",
    Company: "L&t technology services limited",
  },
  {
    Name: "Jigyasa mahur",
    Roll: "17BEC042",
    Company: "Releven -proof will be sent",
  },
  {
    Name: "Jyotika gurnani",
    Roll: "17BEC043",
    Company: "Cypress semiconductor",
  },
  {
    Name: "Kartik madhukeshwar hegde",
    Roll: "17BEC047",
    Company: "L & t limited",
  },
  {
    Name: "Keshav dinesh kasat",
    Roll: "17BEC048",
    Company: "Effiya technologies pvt ltd",
  },
  { Name: "Kunwar vaibhav", Roll: "17BEC049", Company: "Cadence" },
  { Name: "Kv sai akhilesh", Roll: "17BEC050", Company: "Zs associates" },
  { Name: "Malhotra rohan manish", Roll: "17BEC052", Company: "E infochip" },
  { Name: "Meet singh chauhan", Roll: "17BEC053", Company: "Cadence" },
  {
    Name: "Mishra rajiv sushil",
    Roll: "17BEC055",
    Company: "Hashed inn technologies pvt ltd",
  },
  {
    Name: "Naidu hema dinesh",
    Roll: "17BEC056",
    Company: "Accenture india pvt ltd",
  },
  {
    Name: "Naik meet dipakbhai",
    Roll: "17BEC057",
    Company: "Tata consultancy services",
  },
  {
    Name: "Navadiya pratikkumar mukeshbhai",
    Roll: "17BEC058",
    Company: "Synapse- ahmedabad",
  },
  { Name: "Nishith ranabhai poshiya", Roll: "17BEC059", Company: "E infochip" },
  { Name: "Padiya jeel rajesh", Roll: "17BEC060", Company: "Cognizant" },
  { Name: "Pahal chhapiya", Roll: "17BEC061", Company: "Hansen" },
  {
    Name: "Parikh tirth keyurkumar",
    Roll: "17BEC063",
    Company: "Orange business pvt ltd",
  },
  { Name: "Patel deep hiteshbhai", Roll: "17BEC064", Company: "E infochip" },
  {
    Name: "Patel hemang harishbhai",
    Roll: "17BEC065",
    Company: "Tata consultancy services",
  },
  { Name: "Patel mansi amishkumar", Roll: "17BEC066", Company: "Secure meter" },
  { Name: "Patel mosam mukeshbhai", Roll: "17BEC067", Company: "Path partner" },
  {
    Name: "Patel nikhilkumar pareshbhai",
    Roll: "17BEC068",
    Company: "Oracle-cagbu",
  },
  { Name: "Prajapati kush bharatkumar", Roll: "17BEC071", Company: "Oracle" },
  { Name: "Pranshu jain", Roll: "17BEC072", Company: "Infosys" },
  { Name: "Praveen kukreja", Roll: "17BEC073", Company: "Crest data systems" },
  { Name: "Pravishty maheshwari", Roll: "17BEC074", Company: "Cognizant" },
  {
    Name: "Rakholiya abhishek amarutkumar",
    Roll: "17BEC078",
    Company: "Synapse- ahmedabad",
  },
  {
    Name: "Rakkshab varadharajan iyer",
    Roll: "17BEC079",
    Company: "Secure meter",
  },
  { Name: "Ramika chakhaiyar", Roll: "17BEC081", Company: "Zs associates" },
  { Name: "Risha singh", Roll: "17BEC082", Company: "Samsung r&d" },
  { Name: "Rishabh khabya", Roll: "17BEC083", Company: "E infochip" },
  { Name: "Rishabh sharma", Roll: "17BEC084", Company: "Goldman sachs ppo" },
  { Name: "Rohan gupta", Roll: "17BEC088", Company: "Secure meters limited " },
  { Name: "Sagar ashok maheshwari", Roll: "17BEC091", Company: "Xilinx" },
  {
    Name: "Sagar biren patel",
    Roll: "17BEC092",
    Company: "Einfochips ( an arrow company)",
  },
  {
    Name: "Saumya borwankar",
    Roll: "17BEC095",
    Company: "Almstom transportation pvt ltd",
  },
  { Name: "Saurav kiritbhai dekhtawala", Roll: "17BEC096", Company: "Infosys" },
  { Name: "Shah dhruv milan", Roll: "17BEC097", Company: "Cognizant" },
  { Name: "Shah jainam nileshbhai", Roll: "17BEC099", Company: "Glide mtech" },
  {
    Name: "Shah ruchit bankimbhai",
    Roll: "17BEC100",
    Company: "Orange business",
  },
  { Name: "Shah udit tejas", Roll: "17BEC102", Company: "Techsum mic pvt ltd" },
  {
    Name: "Shaikh rehan alam shahnawaz alam",
    Roll: "17BEC103",
    Company: "Commscope pvt ltd",
  },
  { Name: "Sharma devang yogesh", Roll: "17BEC104", Company: "E infochip" },
  {
    Name: "Sharma himanshu govardhan",
    Roll: "17BEC105",
    Company: "Arm embedded technologies",
  },
  { Name: "Shivangi manish shah", Roll: "17BEC106", Company: "E infochip" },
  { Name: "Shraddha pandey", Roll: "17BEC108", Company: "Cognizant" },
  { Name: "Shrey bhatnagar", Roll: "17BEC109", Company: "Infosys" },
  {
    Name: "Tarun kishore khilani",
    Roll: "17BEC116",
    Company: "Geeky bee ai pvt ltd.",
  },
  { Name: "Thaker poojan shaileshhai", Roll: "17BEC117", Company: "Infosys" },
  {
    Name: "Thakor vaibhavkumar jigneshkumar",
    Roll: "17BEC118",
    Company: "Ai monk lab pvt ltd",
  },
  {
    Name: "Tripathi surbhi niteshbhai",
    Roll: "17BEC119",
    Company: "Nbc bearing pvt ltd",
  },
  { Name: "Trivedi jay divyakant", Roll: "17BEC120", Company: "E infochip" },
  {
    Name: "Upadhyay shivanshu rajiv kumar",
    Roll: "17BEC121",
    Company: "Canary mail",
  },
  {
    Name: "Vaghani darshankumar nareshbhai",
    Roll: "17BEC122",
    Company: "Cadence",
  },
  { Name: "Yash deepak shamnani", Roll: "17BEC127", Company: "Searce inc" },
  {
    Name: "Goradiya vatsal akshaybhai",
    Roll: "18BEC151",
    Company: "Monarch innovation pvt ltd , ahmedabad",
  },
  {
    Name: "Parmar kajalben natvarbhai",
    Roll: "18BEC152",
    Company: "Insolar energy pvt. ltd.",
  },
];

export default placedata2021;